import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Target, FileText, MessageSquare } from 'lucide-react';
import { CTAButton } from './CTAButton';
export const WhatsIncluded: React.FC = () => {
  const items = [{
    icon: <BookOpen className="w-7 h-7 md:w-8 md:h-8 text-gold-500" data-id="element-168" />,
    title: 'Guía Principal: KIT Sesiones Clínicas',
    desc: 'El sistema completo para estructurar hasta un año de sesiones con más claridad, continuidad y foco clínico.'
  }, {
    icon: <Target className="w-7 h-7 md:w-8 md:h-8 text-gold-500" data-id="element-169" />,
    title: 'Método SESIÓN 4F',
    desc: 'Un marco simple y poderoso para cada encuentro:\n• FOCO → qué trabajar\n• FLUJO → cómo guiar la sesión\n• FEEDBACK → cómo medir avances\n• FIJACIÓN → cómo cerrar y dar continuidad'
  }, {
    icon: <FileText className="w-7 h-7 md:w-8 md:h-8 text-gold-500" data-id="element-170" />,
    title: 'Paquete de Plantillas Clínicas',
    desc: 'Herramientas listas para aplicar:\n✔ Hoja de sesión clínica\n✔ Seguimiento de paciente\n✔ Checklist pre/post sesión\n✔ Banco de preguntas clínicas'
  }, {
    icon: <MessageSquare className="w-7 h-7 md:w-8 md:h-8 text-gold-500" data-id="element-171" />,
    title: 'Recursos de Intervención',
    desc: 'Para esos momentos donde necesitás mover la sesión sin improvisar.'
  }];
  return <section className="py-12 md:py-20 px-4 bg-navy-900" data-id="element-172">
      <div className="max-w-md md:max-w-4xl mx-auto" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-14" data-id="element-174">
          <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4" data-id="element-175">
            QUÉ INCLUYE EL{' '}
            <span className="text-gold-500" data-id="element-176">KIT SESIONES CLÍNICAS</span>
          </h2>
          <p className="text-base md:text-xl text-gray-300" data-id="element-177">
            Todo lo que necesitás para trabajar con más orden, seguridad y
            dirección clínica:
          </p>
        </motion.div>

        <div className="space-y-4 md:space-y-6 mb-10 md:mb-14" data-id="element-178">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-navy-800 p-5 md:p-8 rounded-xl md:rounded-2xl border border-navy-700 flex gap-4 md:gap-6 items-start" data-id="element-179">
              <div className="bg-navy-900 p-3 md:p-4 rounded-lg md:rounded-xl shrink-0 border border-navy-600" data-id="element-180">
                {item.icon}
              </div>
              <div data-id="element-181">
                <h3 className="text-lg md:text-2xl font-bold mb-2 md:mb-3 text-white" data-id="element-182">
                  {item.title}
                </h3>
                <p className="text-gray-300 text-sm md:text-base leading-relaxed whitespace-pre-line" data-id="element-183">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="flex justify-center" data-id="element-184">
          <CTAButton text="SÍ, QUIERO EL KIT AHORA" data-id="element-185" />
        </div>
      </div>
    </section>;
};